import React, { Component } from "react";
import { RequestHeaders } from "../../common/header-logo/request-header.component";
import { ChartHeaderDropdown } from "../../common/data-header/chart-header-dropdown.component";
import { InternalDataTable, InternalDataTableGrid } from "./invoice-table.component";
import { StatusData } from "../status-data.component";
import InternalManageInvoice from "./manage-invoice.component";
import ManageInvoiceLayout from "../../common/report/reports/Invoice/manage-invoice/manage-invoice-layout.component";
import { Table_View } from "../../../constants/internal-constants";

export class InterNalInvoice extends Component {
    constructor(props) {
        super(props);
        this.state={
            pageNumber:0,
			viewType:Table_View.List,
            tableSelected:false
        }
      }


    openLineItem(data) {
        this.setState({tableSelected:data})
    }


     CloseForm(data) {
        this.setState({tableSelected:data})
    }
    render() {
        
        const ledger=[
            {"Total":931,"Pending":50402,"Approved":696212,"KPI LABEL":0,"Rejected":4}
        ]
        const dataHeader=[
            "",
            "Vendor Name",
            "Vendor Account",
            "Subaccount Number",
            "Invoice Date",
            "Invoice Number",
            "Currency",
            "Assigned To",
            "Net",
            "Tax",
            "Date Upload",
            "Approved Date",
            ""
            ]
        const data= [
            {
                "RowNum": 1,
                "InvoiceID": 2101,
                "InvoiceNum": "10005356489",
                "AccountNumber": "AT&T SIMs",
                "SubAcct_Number": "",
                "VendorName": "AT&T (US)",
                "AssignedTo": "Zerna, Andrei Marie ",
                "InvoiceStatus": "For Audit",
                "InvoiceDate": "11/17/2021",
                "Currency": "USD",
                "Net": 2808,
                "Tax": 11,
                "DateUploaded": "11/17/2021",
                "ApprovedDate": null, 
                "Status":'Rejected'
            }, {
                "RowNum": 2,
                "InvoiceID": 2100,
                "InvoiceNum": "10005356489",
                "AccountNumber": "AT&T SIMs",
                "SubAcct_Number": "",
                "VendorName": "AT&T (US)",
                "AssignedTo": "Zerna, Andrei Marie ",
                "InvoiceStatus": "For Audit",
                "InvoiceDate": "11/17/2021",
                "Currency": "USD",
                "Net": 567,
                "Tax": 16,
                "DateUploaded": "11/17/2021",
                "ApprovedDate": null, 
                "Status":'Pending'
            }, {
                "RowNum": 3,
                "InvoiceID": 2099,
                "InvoiceNum": "10005356489",
                "AccountNumber": "AT&T SIMs",
                "SubAcct_Number": "",
                "VendorName": "AT&T (US)",
                "AssignedTo": "Zerna, Andrei Marie ",
                "InvoiceStatus": "For Audit",
                "InvoiceDate": "11/17/2021",
                "Currency": "USD",
                "Net": 567,
                "Tax": 16,
                "DateUploaded": "11/16/2021",
                "ApprovedDate": null, 
                "Status":'Pending'
            }, {
                "RowNum": 4,
                "InvoiceID": 2098,
                "InvoiceNum": "10005356489",
                "AccountNumber": "AT&T SIMs",
                "SubAcct_Number": "",
                "VendorName": "AT&T (US)",
                "AssignedTo": "Zerna, Andrei Marie ",
                "InvoiceStatus": "For Audit",
                "InvoiceDate": "11/16/2021",
                "Currency": "USD",
                "Net": 567,
                "Tax": 16,
                "DateUploaded": "11/16/2021",
                "ApprovedDate": null, 
                "Status":'Pending'
            }, {
                "RowNum": 5,
                "InvoiceID": 2096,
                "InvoiceNum": "10005356489",
                "AccountNumber": "Softbank",
                "SubAcct_Number": "",
                "VendorName": "Softbank Network (JP)",
                "AssignedTo": "Zerna, Andrei Marie ",
                "InvoiceStatus": "For Audit",
                "InvoiceDate": "11/16/2021",
                "Currency": "USD",
                "Net": 1,
                "Tax": 0,
                "DateUploaded": "11/16/2021",
                "ApprovedDate": null, 
                "Status":'Pending'
            }, {
                "RowNum": 6,
                "InvoiceID": 2095,
                "InvoiceNum": "10005356489",
                "AccountNumber": "AT&T SIMs",
                "SubAcct_Number": "",
                "VendorName": "3G Hutchison (GB)",
                "AssignedTo": "Zerna, Andrei Marie ",
                "InvoiceStatus": "For Audit",
                "InvoiceDate": "11/16/2021",
                "Currency": "ARS",
                "Net": 2,
                "Tax": 1,
                "DateUploaded": "11/16/2021",
                "ApprovedDate": "11/16/2021", 
                "Status":'Approved'
            }, {
                "RowNum": 7,
                "InvoiceID": 2094,
                "InvoiceNum": "10005356489",
                "AccountNumber": "Rogers SIMs",
                "SubAcct_Number": "",
                "VendorName": "Rogers (CA)",
                "AssignedTo": "Zerna, Andrei Marie ",
                "InvoiceStatus": "For Audit",
                "InvoiceDate": "07/12/2021",
                "Currency": "CAD",
                "Net": 17404,
                "Tax": 2258,
                "DateUploaded": "11/15/2021",
                "ApprovedDate": null, 
                "Status":'Pending'
            }, {
                "RowNum": 8,
                "InvoiceID": 2093,
                "InvoiceNum": "10005356489",
                "AccountNumber": "822144889",
                "SubAcct_Number": "",
                "VendorName": "AT&T Mobility (US)",
                "AssignedTo": "Zerna, Andrei Marie ",
                "InvoiceStatus": "For Audit",
                "InvoiceDate": "07/19/2021",
                "Currency": "USD",
                "Net": 816,
                "Tax": 100,
                "DateUploaded": "11/15/2021",
                "ApprovedDate": null, 
                "Status":'Pending'
            }, {
                "RowNum": 9,
                "InvoiceID": 2092,
                "InvoiceNum": "10005356489",
                "AccountNumber": "822144889",
                "SubAcct_Number": "",
                "VendorName": "AT&T Mobility (US)",
                "AssignedTo": "Zerna, Andrei Marie ",
                "InvoiceStatus": "For Audit",
                "InvoiceDate": "07/19/2021",
                "Currency": "USD",
                "Net": 816,
                "Tax": 87,
                "DateUploaded": "11/12/2021",
                "ApprovedDate": null, 
                "Status":'Pending'
            }, {
                "RowNum": 10,
                "InvoiceID": 2092,
                "InvoiceNum": "10005356489",
                "AccountNumber": "822144889",
                "SubAcct_Number": "",
                "VendorName": "AT&T Mobility (US)",
                "AssignedTo": "Zerna, Andrei Marie ",
                "InvoiceStatus": "For Audit",
                "InvoiceDate": "07/19/2021",
                "Currency": "USD",
                "Net": 816,
                "Tax": 87,
                "DateUploaded": "11/12/2021",
                "ApprovedDate": null, 
                "Status":'Pending'
            }, {
                "RowNum": 11,
                "InvoiceID": 2092,
                "InvoiceNum": "10005356489",
                "AccountNumber": "822144889",
                "SubAcct_Number": "",
                "VendorName": "AT&T Mobility (US)",
                "AssignedTo": "Zerna, Andrei Marie ",
                "InvoiceStatus": "For Audit",
                "InvoiceDate": "07/19/2021",
                "Currency": "USD",
                "Net": 816,
                "Tax": 87,
                "DateUploaded": "11/12/2021",
                "ApprovedDate": null, 
                "Status":'Pending'
            }, {
                "RowNum": 12,
                "InvoiceID": 2092,
                "InvoiceNum": "10005356489",
                "AccountNumber": "822144889",
                "SubAcct_Number": "",
                "VendorName": "AT&T Mobility (US)",
                "AssignedTo": "Zerna, Andrei Marie ",
                "InvoiceStatus": "For Audit",
                "InvoiceDate": "07/19/2021",
                "Currency": "USD",
                "Net": 816,
                "Tax": 87,
                "DateUploaded": "11/12/2021",
                "ApprovedDate": null, 
                "Status":'Rejected'
            }];

        const dropdownItem=[
            "Item 1", "Item 2", "Item 3"
        ];  
        const pages={
            HasNext: true,
            HasPrevious: false,
            PageNumber: this.state.pageNumber,
            PerPage: 21,
            TotalEntries: 2453,
            TotalPages: 123

        }

        const tableView = () => {
			if (this.state.viewType == Table_View.List ) {
				return <InternalDataTable getData={this.openLineItem.bind(this)} pages={pages} dataHeader={dataHeader} dataTable={data} statusData={ledger} page="invoice"/>;
			} else {
				return <InternalDataTableGrid getData={this.openLineItem.bind(this)} pages={pages} dataTable={data} statusData={ledger} page="invoice"/>;
			}
		}

        const renderView=(value)=>{
			this.setState({viewType: value})
		}

       

        return(
            <div className="invoice-wrapper-container">
                <RequestHeaders headerTitle="Invoices" />
                {this.state.tableSelected ? 
                    <InternalManageInvoice closeForm={this.CloseForm.bind(this)}/>    
                :

                <div className="request-table data-table request-table-invoice fit-width">
                    <StatusData data={ledger} />
                    <ChartHeaderDropdown haveOneIcone={false} haveIconInfo={false} iconInfo="info-circle-solid" haveLedger={true} ledger={ledger} headerName="Task" circleIcon={true} circleFirstIcon="list-regular" circleSecondIcon="th-solid" oneIcon="vertical-grid" 
                        haveInput={true} haveDropdown={true} dropdownItem={dropdownItem} viewType={renderView} />
                    {tableView()}  
                </div>    
                
                }
               
                       
            </div>
        )
    }
}